import { stringify } from "query-string";
import { SERVER } from "../constants";
import { MAP_URL } from "../constants/urls";
import { HttpClient } from "../utils/requests";
import { productCategoryMapperListResponse } from "../panels/productCategory/productCategoryMapper";
import { productMapperListResponse } from "../panels/product/productMapper";
import { branchMapperListResponse } from "../panels/branch/branchMapper";
import { needMapperListResponse } from "../panels/needs/needMapper";
import { needCategoryMapperListResponse } from "../panels/needCategory/needCategoryMapper";
import { unitMapperListResponse } from "../panels/essentials/unit/unitMapper";
import { mapperListResponse } from "../panels/essentials/unitProcessor/unitProcessorMapper";
import { toEnglishDigits } from '../utils/utils';
import { statusMapperListResponse } from "../panels/essentials/status/statusMapper";
import { statusLoadingMapperListResponse } from "../panels/essentials/statusLoading/statusLoadingMapper";
import { reportMapperListResponse } from "../panels/report/reportMapper";
import { reportstatMapperListResponse } from "../panels/reportstat/reportstatMapper";
import { loadingRequestMapperListResponse } from "../panels/loadingRequest/loadingRequestMapper";
import { whatsappMapperListResponse } from "../panels/whatsapp/whatsappMapper";
import { customerMapperListResponse } from "../panels/crm/customer/customerMapper";
import { preferCallMapperListResponse } from "../panels/essentials/preferCall/preferCallMapper";
import { statusCallMapperListResponse } from "../panels/essentials/statusCall/statusCallMapper";
import { packageMapperListResponse } from "../panels/essentials/package/packageMapper";
import { orderTypeMapperListResponse } from "../panels/essentials/orderType/orderTypeMapper";
import { contactMapperListResponse } from "../panels/crm/contact/contactMapper";
import { adminUserMapperListResponse } from "../panels/adminUsers/adminUsersMapper";
import { customerCategoryMapperListResponse } from "../panels/crm/essentials/customerCategory/customerCategoryMapper";
import { contactCategoryMapperListResponse } from "../panels/crm/essentials/contactCategory/contactCategoryMapper";
// import { CustomerPriorityList } from "../panels/crm/essentials/customerPriority/CustomerPriority";
import { customerPriorityMapperListResponse } from "../panels/crm/essentials/customerPriority/customerPriorityMapper";
import { customerRatingMapperListResponse } from "../panels/crm/essentials/customerRating/customerRatingMapper";
import { storageMapperListResponse } from "../panels/essentials/storage/storageMapper";
import { clueMapperListResponse } from "../panels/crm/clue/clueMapper";
import { reminderMapperListResponse } from "../panels/crm/reminder/reminderMapper";
import { sendSMSMapperListResponse } from "../panels/essentials/sms/SendSMSMapper";
import { notificationsMapperListResponse } from "../panels/essentials/notifications/NotificationsMapper";
import {  transactionMapperListResponse } from "../panels/transaction/transactionMapper";
import { baseUnitMapperListResponse } from '../panels/product/details/baseUnit/baseUnitMapper';
import { productUnitMapperListResponse } from '../panels/product/details/productUnit/productUnitMapper';
import { rawMaterialMapperListResponse } from '../panels/product/details/rawMaterial/rawMaterialMapper';
import { productCapacityMapperListResponse } from "../panels/productCapacity/productCapacityMapper";
import { eventPanelMapperListResponse } from "../panels/event/eventMapper";
import { reportInputProductMapperListResponse } from "../panels/reportInputProducts/reportInputProductsMapper";
import { reportProductionMapperListResponse } from "../panels/reportProduction/reportProductionMapper";





export function getList(resource, params) {
  params = toEnglishDigits(params)
  const { page, perPage } = params.pagination;
  let { field, order } = params.sort;
  let sortKey = field;
  if (['user', 'customerCategory',
    'customerPriority', 'customerRating',
    'contactCategory', 'adminUsers',
    'preferCall', 'orderType',
    'storage',
    'clue', 'reminder',
    'sendSMS',
    'notifications',
    'transaction',
    'productCapacity',
    'eventPanel',
    'package', 'statusCall', 'codes', 'whatsapp', 'product', 'customer', 'contact', 'loadingRequest', 'branch', 'status', 'statusLoading', 'report','reportInputProduct', 'reportstat', 'need', 'unit', 'unitProcessor', 'needCategory', 'productCategory'].includes(resource) && sortKey === 'id') {

    sortKey = 'updatedAt';
  }
  if (['baseUnit', 'productUnit', 'rawMaterial'].includes(resource) && sortKey === 'id') {
    sortKey = 'order';
    order="ASC";

  }
  const query = {
    range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
    sort: JSON.stringify([sortKey, order]),
    from: JSON.stringify((page - 1) * perPage),
    to: JSON.stringify(page * perPage - 1),
    filter: JSON.stringify(params.filter),
    phoneNumber: params.filter.phoneNumber
  };
  const url = `${SERVER}/${MAP_URL[resource]}?${stringify(query)}`;

  return HttpClient(url).then(({ headers, json }) => {
    if (resource === 'productCategory') {
      return productCategoryMapperListResponse(json, headers);
    } else if (resource === 'adminUsers') {
      return adminUserMapperListResponse(json, headers);
    } else if (resource === 'product') {
      return productMapperListResponse(json, headers);
    } else if (resource === 'branch') {
      return branchMapperListResponse(json, headers);
    } else if (resource === 'need') {
      return needMapperListResponse(json, headers);
    } else if (resource === 'needCategory') {
      return needCategoryMapperListResponse(json, headers);
    } else if (resource === 'unit') {
      return unitMapperListResponse(json, headers);
    } else if (resource === 'unitProcessor') {
      return mapperListResponse(json, headers);
    } else if (resource === 'status') {
      return statusMapperListResponse(json, headers);
    } else if (resource === 'statusCall') {
      return statusCallMapperListResponse(json, headers);

    } else if (resource === 'preferCall') {
      return preferCallMapperListResponse(json, headers);


    } else if (resource === 'statusLoading') {
      return statusLoadingMapperListResponse(json, headers);
    } else if (resource === 'report') {
      return reportMapperListResponse(json, headers);
    } else if (resource === 'reportProduction') {
      return reportProductionMapperListResponse(json, headers);
    } else if (resource === 'reportInputProduct') {
      return reportInputProductMapperListResponse(json, headers);

    } else if (resource === 'reportstat') {
      return reportstatMapperListResponse(json, headers);
    } else if (resource === 'loadingRequest') {
      return loadingRequestMapperListResponse(json, headers);
    } else if (resource === 'whatsapp') {
      return whatsappMapperListResponse(json, headers);
    } else if (resource === 'customer') {
      return customerMapperListResponse(json, headers);
    } else if (resource === 'contact') {
      return contactMapperListResponse(json, headers);

    } else if (resource === 'package') {
      return packageMapperListResponse(json, headers);
    } else if (resource === 'orderType') {
      return orderTypeMapperListResponse(json, headers);
    } else if (resource === 'customerCategory') {
      return customerCategoryMapperListResponse(json, headers);
    } else if (resource === 'contactCategory') {
      return contactCategoryMapperListResponse(json, headers);
    } else if (resource === 'customerPriority') {
      return customerPriorityMapperListResponse(json, headers);
    } else if (resource === 'customerRating') {
      return customerRatingMapperListResponse(json, headers);
    } else if (resource === 'storage') {
      return storageMapperListResponse(json, headers);
    } else if (resource === 'clue') {
      return clueMapperListResponse(json, headers);

    } else if (resource === 'reminder') {
      return reminderMapperListResponse(json, headers);
    } else if (resource === 'sendSMS') {
      return sendSMSMapperListResponse(json, headers);
    } else if (resource === 'notifications') {
      return notificationsMapperListResponse(json, headers);

    } else if (resource === 'transaction') {
      return transactionMapperListResponse(json, headers);
    } else if (resource === 'baseUnit') {
      return baseUnitMapperListResponse(json, headers);
    } else if (resource === 'productUnit') {
      return productUnitMapperListResponse(json, headers);
    } else if (resource === 'rawMaterial') {
      return rawMaterialMapperListResponse(json, headers);
    } else if (resource === 'productCapacity') {
      return productCapacityMapperListResponse(json, headers);
    } else if (resource === 'eventPanel') {
      return eventPanelMapperListResponse(json, headers);


    }

    return {
      data: json.map((resource) => ({
        ...resource,
        id: resource.phoneNumber,
      })),
      total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
    };
  });
}
